import { render, staticRenderFns } from "./CoveShedTable.vue?vue&type=template&id=a9a88cbc&scoped=true&"
import script from "./CoveShedTable.vue?vue&type=script&lang=js&"
export * from "./CoveShedTable.vue?vue&type=script&lang=js&"
import style0 from "./CoveShedTable.vue?vue&type=style&index=0&id=a9a88cbc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a9a88cbc",
  null
  
)

export default component.exports